import { AxiosResponse } from "axios";
import { axiosInstance } from "./axiosInstance";

const base = (campusId: number) => `/admin/campus/${campusId}/scheduleCatalog`;

/** Catálogo de Horarios: el mismo JSON que horarios.washingtonacademy.com/api/horarios.json. */
export class ScheduleCatalogService {
	catalogue = async (campusId: number): Promise<AxiosResponse<any>> => axiosInstance.get<any>(base(campusId));

	/** Opciones del filtro Curso / Periodo / Horario de Estudiantes (sección students). */
	studentFilterOptions = async (campusId: number): Promise<AxiosResponse<any>> =>
		axiosInstance.get<any>(`/admin/campus/${campusId}/students/_scheduleFilter`);

	/** Bitácora de copias (auditoría): nunca estorba al usuario si falla. */
	logCopy = async (campusId: number, datos: any): Promise<AxiosResponse<any>> => axiosInstance.post<any>(`${base(campusId)}/_copy`, datos);
}
